module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/dollar_sign_icon-184e1ccf0cd7d256b53086b7edd70e92.svg";